import _default from './eventStack';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/lib/eventStack/index.js
// module id = 2725
// module chunks = 1